export interface ICodReview {
    id: string;
    codId?: string;
    createdAt: Date;
    createdBy: string;
    reason?: string;
}
